import React, { useEffect, useState } from "react";
import { getMatchesCard } from "../services/ScheduleService";
import CompletedMatchCard from "../components/Home/CompletedMatchCard";

function Results() {
    const [activeFilter, setActiveFilter] = useState("All");
    const [matches, setMatches] = useState([]);

    useEffect(() => {
        const fetchData = () => {
            getMatchesCard("completed").then((data) => {
                if (data && data.matches) {
                    const completed = data.matches.filter(m => m.matchEndTime);
                    setMatches(completed);
                }
            });
        };

        fetchData();
        const interval = setInterval(fetchData, 30000);
        return () => clearInterval(interval);
    }, []);

    const filterMatches = () => {
        const now = new Date();
        const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const weekStart = new Date(todayStart);
        weekStart.setDate(weekStart.getDate() - 7);

        if (activeFilter === "Today") {
            return matches.filter(m => new Date(m.matchStartTime) >= todayStart);
        } else if (activeFilter === "This Week") {
            return matches.filter(m => new Date(m.matchStartTime) >= weekStart);
        }
        return matches;
    };

    return (
        <div id="section-results" className="spanel active">
            <div className="main-wrap" style={{ padding: "18px 0" }}>
                <div className="fbar">
                    <button className={`fbtn ${activeFilter === "All" ? "active" : ""}`} onClick={() => setActiveFilter("All")}>All</button>
                    <button className={`fbtn ${activeFilter === "Today" ? "active" : ""}`} onClick={() => setActiveFilter("Today")}>Today</button>
                    <button className={`fbtn ${activeFilter === "This Week" ? "active" : ""}`} onClick={() => setActiveFilter("This Week")}>This Week</button>
                </div>
                <div className="sh">All Results</div>

                {filterMatches().length === 0 && (
                    <p style={{ color: "var(--text2)", padding: "20px 0" }}>No results found.</p>
                )}

                {filterMatches().map((match) => (
                    <CompletedMatchCard key={match.matchId} match={match} />
                ))}
            </div>
        </div>
    );
}

export default Results;